import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Super admins may open salon routes only while impersonating (or otherwise having tenantId).
 */
const SalonTenantRoute = () => {
  const { role, tenantId, isImpersonating } = useAuth();

  if (role === 'SUPER_ADMIN' && !tenantId && !isImpersonating) {
    return <Navigate to="/admin/tenants" replace />;
  }

  return <Outlet />;
};

export default SalonTenantRoute;
